import _defaultTheme from './theme.default'
import _global from './global'

export const GlobalStyle = _global
export const defaultTheme = _defaultTheme

